import { useState } from 'react';
import ImageLoader from '../components/ImageLoader'
import Lightbox from '../components/Lightbox';
import ThumbnailPicker from '../components/ThumbnailPicker'


const items = [
    { src:require("../images/interiors/img--interiors-1.jpg").default, caption:"LIVING", x:707, y:205, width:385, height:246 },
    { src:require("../images/interiors/img--interiors-2.jpg").default, caption:"LIVING & DINING", x:1109, y:205, width:347, height:246 },
    { src:require("../images/interiors/img--interiors-3.jpg").default, caption:"LIVING", x:1473, y:205, width:347, height:246 },
    { src:require("../images/interiors/img--interiors-4.jpg").default, caption:"EXTERIOR BALCONY", x:707, y:469, width:382, height:246 },
    { src:require("../images/interiors/img--interiors-5.jpg").default, caption:"KITCHEN & DINING", x:1109, y:469, width:347, height:246 },
    { src:require("../images/interiors/img--interiors-6.jpg").default, caption:"KITCHEN & LIVING", x:1473, y:469, width:347, height:246 },
    { src:require("../images/interiors/img--interiors-7.jpg").default, caption:"KITCHEN & DINING", x:707, y:734, width:285, height:245 },
    { src:require("../images/interiors/img--interiors-8.jpg").default, caption:"WALK IN ROBE", x:1011, y:733, width:259, height:245 },
    { src:require("../images/interiors/img--interiors-9.jpg").default, caption:"ENSUITE", x:1288, y:735, width:256, height:245 },
    { src:require("../images/interiors/img--interiors-10.jpg").default, caption:"BATHROOM", x:1564, y:736, width:256, height:243 },

]


export default function(){
    const [selection, setSelection] = useState<string|null>(null);

    return (
        <div>
            <ThumbnailPicker onSelected={setSelection} items={items}/>
            <Lightbox items={items} selection={selection} onSelected={setSelection} carousel={true}/>
            <ImageLoader src={require("../images/interiors/bkg--interiors-1.jpg").default} />
        </div>
    )
}